import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logoService } from '../services/logo.service';

interface UploadLogoParams {
  companyId: string;
  file: File;
}

export function useUploadLogo(): {
  uploadLogo: (params: UploadLogoParams) => void;
  uploadLogoAsync: (params: UploadLogoParams) => Promise<unknown>;
  uploadDarkLogo: (params: UploadLogoParams) => void;
  uploadDarkLogoAsync: (params: UploadLogoParams) => Promise<unknown>;
  isUploading: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const uploadLogoMutation = useMutation({
    mutationFn: ({ companyId, file }: UploadLogoParams) => logoService.uploadLogo(companyId, file),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['company', companyId] });
    },
  });

  const uploadDarkLogoMutation = useMutation({
    mutationFn: ({ companyId, file }: UploadLogoParams) =>
      logoService.uploadDarkLogo(companyId, file),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['company', companyId] });
    },
  });

  return {
    uploadLogo: uploadLogoMutation.mutate,
    uploadLogoAsync: uploadLogoMutation.mutateAsync,
    uploadDarkLogo: uploadDarkLogoMutation.mutate,
    uploadDarkLogoAsync: uploadDarkLogoMutation.mutateAsync,
    isUploading: uploadLogoMutation.isPending || uploadDarkLogoMutation.isPending,
    error: uploadLogoMutation.error || uploadDarkLogoMutation.error,
  };
}
